<div>
  <div
    [ngClass]="'message bot'"
    [ngStyle]="getMessageStyles()"
    [innerHTML]="messageText"
  ></div>
  <div class="display-flex flex-space-between" style="width: 94%">
    <app-message-timestamp
      *ngIf="input.created_at && input.created_at > 0"
      [createdAt]="input.created_at"
    >
    </app-message-timestamp>
  </div>
  <div *ngIf="lastMessage" class="confirm-dialog">
    <div class="confirm-dialog__content">
      <div class="content-section" [ngClass]="getIconClass()">
        <mat-icon class="d-none">{{ iconType }}</mat-icon>
        <p  [ngStyle]="{
                'font-family': configs?.fonts?.chat_menu_font || configs?.fonts?.default_font,
              }">{{ messageText }}</p>
      </div>
      <div 
      class="confirm-dialog__actions popup-btn-row"
      >
        @for(button of buttonItems; track $index; let i = $index) {
        <button
          class="primary-btn"
          mat-stroked-button
          (click)="onButtonClick(button)"
          [ngStyle]="{
                'font-family': configs?.fonts?.chat_menu_font || configs?.fonts?.default_font,
              }"
        >
          {{ button.label }}
        </button>
        }
      </div>
    </div>
  </div>
</div>
